import { FETCH_USERS_UNITS, FETCH_USER_UNITS} from "../actions/types";

export default (state = "loading", action) => {
  switch (action.type) {
    case FETCH_USERS_UNITS:
      return action.payload;
    case FETCH_USER_UNITS:
      if(state !== "loading"){
        let newState = {...state}
        if(newState[action.packageId])newState[action.packageId] = {...newState[action.packageId], [action.userId]: action.payload}
        else newState[action.packageId] = {[action.userId]: action.payload}
        return newState
      }
      else return {[action.packageId]: {[action.userId]:action.payload}}
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/usersUnitsReducer.js